(function($){

    var moduleNum = 0;

    if ( $('.post-listing-module').length ){
        $('.post-listing-module').each(function(){

            $(this).attr('id', 'moduleNum-' + moduleNum);

            /*$('.tag-filter input').on('change', function () {
              if(!$(this).hasClass('checked')){
                $('.tag-filter input').prop('checked',false);
                $(this).prop('checked',true);
                $('.tag-filter input').removeClass('checked')
                $(this).addClass('checked');
                var filter_values = $(this).val();
                var current_cat = $(this).parents('.post-listing-module').attr('data-category');
                var showtags = $(this).parents('.post-listing-module').attr('data-showtags');
                $('html').addClass('loading-cursor');

                ajax_filter_send(filter_values, current_cat, showtags);
              }else{
                $(this).removeClass('checked');
                var filter_values = null;
                var current_cat = $(this).parents('.post-listing-module').attr('data-category');
                var showtags = $(this).parents('.post-listing-module').attr('data-showtags');
                $('html').addClass('loading-cursor');

                ajax_filter_send(filter_values, current_cat, showtags);
              }
            });*/

            /********* TAG FILTER ***********/
            $(this).find('.tag-filter label').on('click', function () {
                if(!$(this).hasClass('checked')){
                    $(this).parents('.post-listing-module').find('.tag-filter label').removeClass('checked')
                    $(this).addClass('checked');
                    var filter_values = $(this).attr('data-tagId');
                    var photographer_values = 'all';
                    var product_values = 'all';
                    var product_values = 'all';
                    var level_values = 'all';
                    var current_cat = $(this).parents('.post-listing-module').attr('data-category');
                    var showtags = $(this).parents('.post-listing-module').attr('data-showtags');
                    var moduleNum =  $(this).parents('.post-listing-module').attr('id');
                    var maxPost = $(this).parents('.post-listing-module').attr('data-maxPost');
                    $('html').addClass('loading-cursor');

                    ajax_filter_send(filter_values, current_cat, showtags, moduleNum, maxPost, product_values, photographer_values, level_values);
                }else{
                    $(this).removeClass('checked');
                    var filter_values = 'all';
                    var photographer_values = 'all';
                    var product_values = 'all';
                    var level_values = 'all';
                    var current_cat = $(this).parents('.post-listing-module').attr('data-category');
                    var showtags = $(this).parents('.post-listing-module').attr('data-showtags');
                    var moduleNum =  $(this).parents('.post-listing-module').attr('id');
                    var maxPost = $(this).parents('.post-listing-module').attr('data-maxPost');
                    $('html').addClass('loading-cursor');

                    ajax_filter_send(filter_values, current_cat, showtags, moduleNum, maxPost, product_values, photographer_values, level_values);
                }
            });

            /********* Load more ***********/
            if($(this).hasClass('see-all-btn-off')) {
                /*$(window).scroll(function (e) {
                    var position = $(window).scrollTop();
                    var bottom = $(document).height() - ($('.newsletter-section').outerHeight(true) + $('.footer-section').outerHeight(true)) - $(window).height();

                    if (position >= bottom) {

                        if ($('.post-listing-module').find('.select-photographers-filter select').length) {
                            var photographer_values = $('.post-listing-module').find('.select-photographers-filter select').val();
                        } else {
                            var photographer_values = 'all';
                        }
                        if ($('.post-listing-module').find('.select-products-filter select').length) {
                            product_values = $('.post-listing-module').find('.select-products-filter select').val();
                        } else {
                            var product_values = 'all';
                        }
                        if ($('.post-listing-module').find('.select-levels-filter select').length) {
                            level_values = $('.post-listing-module').find('.select-levels-filter select').val();
                        } else {
                            var level_values = 'all';
                        }
                        if ($('.post-listing-module').find('.select-tags-filter select').length) {
                            var filter_values = $('.post-listing-module').find('.select-tags-filter select').val();
                        } else {
                            var filter_values = $('.post-listing-module').find('.tag-filter label.checked').attr('data-tagId');
                        }

                        var current_cat = $('.post-listing-module').attr('data-category');
                        var offset = $('.load-more').attr('data-count-post');
                        var showtags = $('.post-listing-module').attr('data-showtags');
                        var moduleNum = $('.post-listing-module').attr('id');
                        $('.post-listing-module').find('.spinner').fadeIn();

                        load_more(filter_values, current_cat, offset, showtags, moduleNum, product_values, photographer_values, level_values);

                    }
                });*/
            }

            $(this).find('.load-more').on('click', function(e){
                // prevent action
                e.preventDefault();
                if( $(this).parents('.post-listing-module').find('.select-photographers-filter select').length ){
                    var photographer_values = $(this).parents('.post-listing-module').find('.select-photographers-filter select').val();
                }else{
                    var photographer_values = 'all';
                }
                if( $(this).parents('.post-listing-module').find('.select-products-filter select').length ){
                    product_values = $(this).parents('.post-listing-module').find('.select-products-filter select').val();
                }else{
                    var product_values = 'all';
                }
                if( $(this).parents('.post-listing-module').find('.select-levels-filter select').length ){
                    level_values = $(this).parents('.post-listing-module').find('.select-levels-filter select').val();
                }else{
                    var level_values = 'all';
                }
                if($(this).parents('.post-listing-module').find('.select-tags-filter select').length){
                    var filter_values = $(this).parents('.post-listing-module').find('.select-tags-filter select').val();
                }else{
                    var filter_values = $(this).parents('.post-listing-module').find('.tag-filter label.checked').attr('data-tagId');
                }

                var current_cat = $(this).parents('.post-listing-module').attr('data-category');
                var offset = $(this).attr('data-count-post');
                var showtags = $(this).parents('.post-listing-module').attr('data-showtags');
                var moduleNum =  $(this).parents('.post-listing-module').attr('id');
                $(this).hide();
                $(this).parents('.post-listing-module').find('.spinner').fadeIn();

                load_more(filter_values,current_cat,offset,showtags,moduleNum, product_values, photographer_values, level_values);
            });


            /********* MIX FILTER ***********/
            $(this).find('.select-tags-filter select').on('change', function () {
                var filter_values = $(this).val();
                var product_values = $(this).parents('.post-listing-module').find('.select-products-filter select').val();
                var photographer_values = $(this).parents('.post-listing-module').find('.select-photographers-filter select').val();
                var level_values = $(this).parents('.post-listing-module').find('.select-levels-filter select').val();
                var current_cat = $(this).parents('.post-listing-module').attr('data-category');
                var showtags = $(this).parents('.post-listing-module').attr('data-showtags');
                var moduleNum =  $(this).parents('.post-listing-module').attr('id');
                var maxPost = $(this).parents('.post-listing-module').attr('data-maxPost');
                $('html').addClass('loading-cursor');
                /*console.log(filter_values);
                console.log(product_values);
                console.log(photographer_values);
                console.log(level_values);*/

                ajax_filter_send(filter_values, current_cat, showtags, moduleNum, maxPost, product_values, photographer_values, level_values);
            });
            $(this).find('.select-products-filter select').on('change', function () {
                var product_values = $(this).val();
                var photographer_values = $(this).parents('.post-listing-module').find('.select-photographers-filter select').val();
                var filter_values = $(this).parents('.post-listing-module').find('.select-tags-filter select').val();
                var level_values = $(this).parents('.post-listing-module').find('.select-levels-filter select').val();
                var current_cat = $(this).parents('.post-listing-module').attr('data-category');
                var showtags = $(this).parents('.post-listing-module').attr('data-showtags');
                var moduleNum =  $(this).parents('.post-listing-module').attr('id');
                var maxPost = $(this).parents('.post-listing-module').attr('data-maxPost');
                $('html').addClass('loading-cursor');
                /*console.log(filter_values);
                console.log(product_values);
                console.log(photographer_values);
                console.log(level_values);*/

                ajax_filter_send(filter_values, current_cat, showtags, moduleNum, maxPost, product_values, photographer_values, level_values);
            });
            $(this).find('.select-photographers-filter select').on('change', function () {
                var photographer_values = $(this).val();
                var product_values = $(this).parents('.post-listing-module').find('.select-products-filter select').val();
                var filter_values = $(this).parents('.post-listing-module').find('.select-tags-filter select').val();
                var level_values = $(this).parents('.post-listing-module').find('.select-levels-filter select').val();
                var current_cat = $(this).parents('.post-listing-module').attr('data-category');
                var showtags = $(this).parents('.post-listing-module').attr('data-showtags');
                var moduleNum =  $(this).parents('.post-listing-module').attr('id');
                var maxPost = $(this).parents('.post-listing-module').attr('data-maxPost');
                $('html').addClass('loading-cursor');
                /*console.log(filter_values);
                console.log(product_values);
                console.log(photographer_values);
                console.log(level_values);*/

                ajax_filter_send(filter_values, current_cat, showtags, moduleNum, maxPost, product_values, photographer_values, level_values);
            });
            $(this).find('.select-levels-filter select').on('change', function () {
                var level_values = $(this).val();
                var photographer_values = $(this).parents('.post-listing-module').find('.select-photographers-filter select').val();
                var product_values = $(this).parents('.post-listing-module').find('.select-products-filter select').val();
                var filter_values = $(this).parents('.post-listing-module').find('.select-tags-filter select').val();
                var current_cat = $(this).parents('.post-listing-module').attr('data-category');
                var showtags = $(this).parents('.post-listing-module').attr('data-showtags');
                var moduleNum =  $(this).parents('.post-listing-module').attr('id');
                var maxPost = $(this).parents('.post-listing-module').attr('data-maxPost');
                $('html').addClass('loading-cursor');
                /*console.log(filter_values);
                console.log(product_values);
                console.log(photographer_values);
                console.log(level_values);*/

                ajax_filter_send(filter_values, current_cat, showtags, moduleNum, maxPost, product_values, photographer_values,level_values);
            });

            moduleNum++;
        });

        /*if ( $('.tag-filter').length ){
            //Detecte si le nombre de tab dépasse la taille total du menu
            var totalWidth = 0;
            $('.tag-filter').find('label:not(.slick-cloned)').each(function () {
                totalWidth += parseInt($(this).outerWidth(true), 10);
            });
            var containerWidth = $('.tag-filter').outerWidth();

            var i = 0;

            $('.tag-filter label:not(.slick-cloned)').each(function () {
                $(this).attr("data-num", i);
                i++;
            });

            if (containerWidth > totalWidth) {
                var slideToshow = 99;
                $('.tag-filter.slick-slider').slick('unslick');
            } else {

                $('.tag-filter').slick({
                    slidesToShow: slideToshow,
                    focusOnSelect: true,
                    arrows: false,
                    speed: 500,
                    variableWidth: true,
                    dots: false,
                });

            }
        }*/
    }

    function ajax_filter_send (filter_values, current_cat, showtags, moduleNum, maxPost, product_values, photographer_values, level_values) {
    $.ajax({
        url: ajax.url,
        method:'POST',
        data: {
            action : 'filter_post',
            filter_values : filter_values,
            current_cat : current_cat,
            showtags : showtags,
            moduleNum : moduleNum,
            maxPost : maxPost,
            product_values: product_values,
            photographer_values : photographer_values,
            level_values : level_values
        },
        success:function(response){
            var donnees = JSON.parse(response);
            $('#' + moduleNum + ' .post-listing').html(donnees.content);
            $('#' + moduleNum + ' .load-more').attr('data-count-post', donnees.count);

            if(donnees.delete_btn == true){
                $('#' + moduleNum + ' .load-more').hide();
                $('#' + moduleNum + ' .spinner').hide();
            }else{
                $('#' + moduleNum + ' .load-more').fadeIn();
                $('#' + moduleNum + ' .spinner').hide();
            }
        },
        error: function(xhr, textStatus){

        },
        complete: function(){
            $('html').removeClass('loading-cursor');
        }
    });
}
    function load_more(filter_values,current_cat,offset,showtags,moduleNum, product_values, photographer_values, level_values){

    var $result = $.ajax({
        url: ajax.url,
        method: 'POST',
        async: false,
        cache: false,
        timeout: 30000,
        data:{
            action: 'load_more',
            offset : offset,
            filter_values : filter_values,
            current_cat : current_cat,
            showtags : showtags,
            moduleNum:moduleNum,
            product_values: product_values,
            photographer_values : photographer_values,
            level_values : level_values,
        },
        error: function (){
            return true;
        },
        success:function(response){
            var donnees = JSON.parse(response);
            $('#' + moduleNum + ' .post-listing').append(donnees.content);
            $('#' + moduleNum + ' .load-more').attr('data-count-post', donnees.new_offset);

            if(donnees.delete_btn == true){
                $('#' + moduleNum + ' .load-more').fadeOut();
                $('#' + moduleNum + ' .spinner').hide();
            }else{
                $('#' + moduleNum + ' .load-more').fadeIn();
                $('#' + moduleNum + ' .spinner').hide();
            }
            return true;
        },
        error: function(xhr, textStatus){
        },
        complete: function(){
            console.log('complete');
        }
    });
}

})(jQuery);